export default {
  discount_types: {
    cashback: 'Kanta-asiakaspisteet',
    promo_code: 'Alennuskoodi',
  },
  input: {
    label: '{{cashbackLabel}} tai {{promoCodeLabel}}',
    placeholder: 'Alennuskoodi',
  },
  buttons: {
    apply: 'Käytä',
    remove: 'Poista',
  },
  feedback: {
    login:
      '<highlight>Kirjaudu sisään</highlight> käyttääksesi tätä koodia, jotta voimme varmistaa, ettet ole käyttänyt sitä vielä. Kirjaudu sisään ja yritä uudelleen.',
    usage_threshold: 'Tämän koodin vähimmäisostoskorisumma on (ilman toimituskuluja)',
    promo_code_added: 'Alennuskoodi lisätty onnistuneesti',
  },
};
